import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_TRANSACTION_EDIT: MijnRoute = {
    path: 'transactie-notificatie/:id',
    navigationEvent: 'toTransactieNotificatie',
    regex: /^\/zelf-regelen\/notificaties-beheren\/transactie-notificatie\/[^/]+$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/transactie-notificatie/:id'
};
